<template>
    <p :for="forElement" :aria-label="getAriaLabel()">
        <template v-for="(captionPart, j) in getCaptionArray()">
            <span v-if="j % 2 === 0" class="legalTextContent" :key="'legalTextContent-' + j">{{captionPart}}</span>
            <button type="button" tabindex="-1" v-else-if="docType !== ''" class="ciam-legal-link-button"
                    :id="'link-legalText-' + captionPart[1]"
                    @click.prevent="onClick(captionPart[1], docType)" :key="'legalTextButton-' + j">
                {{ captionPart[0] }}
            </button>
            <button type="button" tabindex="-1" v-else class="ciam-legal-link-button"
                    :id="'link-legalText-' + captionPart[1]"
                    @click.prevent="onClick(captionPart[1])" :key="'legalTextButton-' + j">
                {{ captionPart[0] }}
            </button>
        </template>
    </p>
</template>

<script>

export default {
  props: {
    // ID of the element this label belongs to
    forElement: {
      type: String,
      default: ''
    },
    // Text to display next to the checkbox (contains the placeholders, e.g. {0})
    caption: {
      type: String,
      default: ''
    },
    // The legal texts associated with this checkbox (a text consists of a title and an ID)
    texts: {
      type: Array,
      default: () => []
    },
    // Title of the consent item
    title: {
      type: String,
      default: ''
    },
    // Id of the consent item
    id: {
      type: Number,
      default: 0
    },
    // DocType of the consent item
    docType: {
      type: String,
      default: ''
    },
    // The function that is to be called when pressing a link in the checkbox text
    onClick: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    getCaptionArray: function () {
      const linkCaption = this.caption.split(new RegExp('({[0-9]})'))
      // caption has no placeholder
      if (linkCaption.length === 1) {
        linkCaption[1] = [this.title, this.id]
      // caption has placeholder
      } else {
        let j = 0
        for (let i = 0; i < linkCaption.length; i++) {
          if (i % 2 === 1) {
            if (this.title !== '') {
              linkCaption[i] = [this.title, this.id]
            } else {
              linkCaption[i] = [this.texts[j].title, this.texts[j].id]
            }
            j++
          }
        }
      }
      return linkCaption
    },
    getAriaLabel: function () {
      const raw = this.caption.split(new RegExp('({[0-9]})'))
      if (raw.length === 1) {
        raw[1] = this.title
      } else {
        let j = 0
        for (let i = 0; i < raw.length; i++) {
          if (i % 2 === 1) {
            if (this.title !== '') {
              raw[i] = this.title
            } else {
              raw[i] = this.texts[j].title
            }
            j++
          }
        }
      }
      return raw.join('')
    }
  }
}
</script>
<style>
    .legalTextContent {
        cursor: default;
    }
</style>
